var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteBinLine = function SvgDeleteBinLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 6.6h4.5v1.8h-1.8v11.7a.9.9 0 0 1-.9.9H6.2a.9.9 0 0 1-.9-.9V8.4H3.5V6.6H8V3.9a.9.9 0 0 1 .9-.9h7.2a.9.9 0 0 1 .9.9zm.9 1.8H7.1v10.8h10.8zm-8.1 2.7h1.8v5.4H9.8zm3.6 0h1.8v5.4h-1.8zM9.8 4.8v1.8h5.4V4.8z"
  })));
};
export default SvgDeleteBinLine;